// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1wmqn","options":"AnswerScale_options__3uuvh","selected":"AnswerScale_selected__R4rW3"};